import { logPatches } from "./reducerHelpers/logging"
import { enablePatches, produceWithPatches } from "immer";

enablePatches();

export const rts = {
  handleGroupItem_left: 'handleGroupItem_left',
  handleGroupItem_right: 'handleGroupItem_right',
}

export const settingsFrameworkReducer = (state, action) => {

  const { type, groupItem } = action

  const [nextState, patches, inversePatches] = produceWithPatches(
    state,
    draft => {
      switch (type) {

        case rts.handleGroupItem_left:
          return {
            ...state,
            leftSidebarGroupItem: groupItem
          }

        case rts.handleGroupItem_right:
          return {
            ...state,
            rightSidebarGroupItem: groupItem
          }

        default:
          return { ...state }
      }
    }
  )

  logPatches('settingsFramework', type, patches, action, nextState);

  return nextState;

}

export const settingsFrameworkInitialState = (settingsMenuType) => {
  const s = {
    settingsMenuType,
  }
  return s
};

export const settingsFrameworkHandlers = (dispatch) => {
  return {
    handleGroupItem_left: (groupItem) => { dispatch({ type: rts.handleGroupItem_left, groupItem }) },
    handleGroupItem_right: (groupItem) => { dispatch({ type: rts.handleGroupItem_right, groupItem }) },
  }
}